import { createSlice } from "redux-starter-kit";
// Split into pending and active filters.
const initialState = { pending: {}, active: {} };
const feedFilters = createSlice({
    slice: "feedFilters",
    initialState,
    reducers: {
        setActiveFilters(state, action) {
            // State can be modified directly when inside createSlice
            state.active = action.payload;
        },
        setPendingFilters(state, action) {
            state.pending = action.payload;
        },
        clearFilters(state) {
            state = initialState;
            return state;
        },
        clearActiveFilters(state) {
            state.active = initialState.active;
        },
        clearPendingFilters(state) {
            state.pending = initialState.pending;
        }
    }
});

// Extract the action creators object and the reducer
const { actions, reducer } = feedFilters;
// Extract and export each action creator by name
export const { setActiveFilters, clearFilters, clearActiveFilters, clearPendingFilters } = actions;
// Export the reducer, either as a default or named export
export default reducer;
